import { setEditingTaskMessage } from './events';
import { $editingTaskMessage } from './states';

import '../modals/TaskMessageTemplatePickerModal/store/init';
import '../modals/AddTaskDeliverableAttachmentModal/store/init';

// Set editing client note
$editingTaskMessage.on(setEditingTaskMessage, (_, editingTaskMessage) => editingTaskMessage);
